// src/Capacitor/updater/initHotUpdateManager.ts
import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { hotUpdateManager } from '@/capacitor/updater/hotupdate';

// 初始化热更新管理器
// - 仅在原生平台启用真实热更逻辑，Web 环境跳过（但 DEV 时可做预览）
// 先调用 CapacitorUpdater.notifyAppReady()，再 init(hotUpdateManager)
export async function initHotUpdateManager(): Promise<void> {
  // console.log('=== 开始初始化热更新管理器 ===');
  // console.log('当前平台:', Capacitor.getPlatform());
  // console.log('是否为原生平台:', Capacitor.isNativePlatform());
  if (!Capacitor.isNativePlatform()) {
    // console.log('热更新仅在原生平台可用，跳过初始化');
    return;
  }
  try {
    // console.log('热更新管理器初始化：目录已在应用启动时创建');
    // ✅ 先通知 Updater 插件应用已就绪（防止回滚）
    try {
      // console.log('通知CapacitorUpdater应用已就绪...');
      // 启动确认
      await CapacitorUpdater.notifyAppReady();
      // console.log('CapacitorUpdater.notifyAppReady 调用成功');
    } catch (e) {
      // console.warn('CapacitorUpdater.notifyAppReady 调用失败（可忽略首启时机差异）', e);
    }
    // 再初始化 hotUpdateManager（执行检查 / 定时任务等）
    await hotUpdateManager.init({
      externalStoragePath: 'Download/d3/upgrade',
      enabled: false
      // checkInterval: 30 * 60 * 1000, // 如需启用可传入
    });

    // DEV: 若需要可在此处由调用方执行 previewConfirmModal（或在 main.ts 做）
    // console.log('=== 热更新管理器已成功初始化 ===');
  } catch (error) {
    // console.error('=== 热更新管理器初始化失败 ===', error);
    // 兜底：尝试手动调试目录访问权限（保留你原有的调试逻辑）
    try {
      // console.log('尝试手动调试目录访问权限...');
      await hotUpdateManager.debugDirectoryAccess();
    } catch (debugError) {
      // console.error('手动调试也失败:', debugError);
    }
  }
}
